import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-communication',
  standalone: true,
  imports: [],
  templateUrl: './process-communication.component.html',
  styles: ``
})
export class ProcessCommunicationComponent {
  @Input() process!: Process;
}
